import { func } from 'prop-types';
import React, { useEffect, useState } from 'react'
import './FilterGeneric.css'
import { useDispatch, useSelector } from 'react-redux';
import { setFilterChangedId } from '../../services/store/GenericReducer';


export default function FilterGeneric(props) {

    const store = useSelector(state => state.reducer)
    const [showDropDown, setShowDropDown] = useState(false)
    const [filterValue, setFilterValue] = useState(false)
    const [filterDisplay, setFilterDisplay] = useState(props.apiFilter)
    const dispatch = useDispatch();

    useEffect(() => {
        if (filterValue) {
            setFilterDisplay(filterValue)
        }

        // Always call updateFilter when filterValue changes (including when clearing to false)
        if (props.apiFilter?.filterTypeID !== undefined) {
            props.updateFilter(props.apiFilter.filterTypeID, filterValue)
        }

        // Update filterChangedId after updateFilter
        if(!filterValue && store.filterChangedId.includes(props.apiFilter.filterTypeID)){
            let index = store.filterChangedId.indexOf(props.apiFilter.filterTypeID);
            if (index > -1) {
                let newArray = [...store.filterChangedId];
                newArray.splice(index, 1);
                dispatch(setFilterChangedId(newArray))
            }
        }
    }, [filterValue])

    // Set filter value from store.filterChoices (including URL filters)
    // Looks up full data if filter came from URL (has _fromUrl flag)
    useEffect(() => {
        const storeChoice = store.filterChoices?.[props.apiFilter.filterTypeID]?.choice
        if (!storeChoice) return

        // Check if we need to do URL lookup (either no filterValue yet, or current value still has _fromUrl flag)
        const needsLookup = !filterValue || filterValue._fromUrl

        if (needsLookup && storeChoice._fromUrl) {
            // Try to look up full data from available options
            if (props.filter?.length > 0) {
                const fullData = props.filter.find(item =>
                    item.id === storeChoice.id || item.name === storeChoice.name
                )
                if (fullData) {
                    setFilterValue(fullData)
                    setFilterDisplay(fullData)
                    return
                }
            }
            // Set filterValue for functionality, but don't set filterDisplay yet (wait for lookup)
            if (!filterValue) {
                setFilterValue(storeChoice)
            }
            return
        }

        // Set value if not set yet (non-URL case - has title already)
        if (!filterValue) {
            setFilterValue(storeChoice)
            setFilterDisplay(storeChoice)
        }
    }, [store.filterChoices?.[props.apiFilter?.filterTypeID]?.choice, props.filter])

    useEffect(() => {
        props.clearFilterLabel > 0 && setFilterDisplay(props.apiFilter)
        props.clearFilterLabel > 0 && setFilterValue(false)
    }, [props.clearFilterLabel])

    return (
        <div onClick={() => setShowDropDown(!showDropDown)} className={`field-wrapper dropdown ${props.iconDiff && 'filter-fields-dropdown'} ${showDropDown && 'show'}`}> 
            <label htmlFor="filter-type" className="sr-only">{props.apiFilter.title}</label>
            <div className="input-with-icon"> 
                {props.children}
                <input type="text" id="filter-type" className={filterValue ? "text-blue" : ""} placeholder={filterDisplay.title} readOnly={true}/> 
                <span className="dropdown-arrow"></span> 
            </div>
            <div className="dropdown-content">
                <div className="list-container">
                    <ul>
                        <li onClick={() => {setFilterDisplay(props.apiFilter); setFilterValue(false)}}> X נקה בחירה</li>
                        {
                            props.filter?.map((item, index) => {
                                return <li key={index} onClick={() => setFilterValue(item)} data-param-name="filterFieldDisplay"> <a>{item.title}</a> </li>
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}
